import React, { useState } from 'react'
import 'styles/EditActivityModal.css'
import { useTranslation } from 'react-i18next'
import { getOnChangeFunction } from 'utils'
import ButtonComponent from 'components/common/ButtonComponent'

const EditActivityModal = ({ activity, onClose, onSave }) => {
  const { t } = useTranslation()
  const [localActivity, setLocalActivity] = useState({ ...activity })

  const onChange = getOnChangeFunction(setLocalActivity, localActivity)
  const handleSave = () => onSave(localActivity)

  return (
    <div className='edit-activity-modal-overlay'>
      <div className='edit-activity-modal'>
        <div className='pb-3'>
          <h3 className='text-lg font-semibold text-greenPrimary'>{t('mgmt.activityModal.editTitle')}</h3>
        </div>

        <div className='edit-activity-content'>
          <div className='activity-details'>
            <h4>{t('mgmt.activityModal.details')}</h4>

            <div className='form-group'>
              <label>{t('mgmt.activityModal.name')} *</label>
              <input
                type='text'
                name='activityName'
                value={localActivity.activityName}
                onChange={onChange}
                required
              />
            </div>

            <div className='checkbox-group'>
              <label>
                <input
                  type='checkbox'
                  name='isActive'
                  checked={localActivity.isActive}
                  onChange={onChange}
                />
                {t('mgmt.activityModal.active')}
              </label>

              <label>
                <input
                  type='checkbox'
                  name='allDevices'
                  checked={localActivity.allDevices}
                  onChange={onChange}
                />
                {t('mgmt.activityModal.allDevices')}
              </label>

              <label>
                <input
                  type='checkbox'
                  name='shared'
                  checked={localActivity.shared}
                  onChange={onChange}
                />
                {t('mgmt.activityModal.shared')}
              </label>

              <label>
                <input
                  type='checkbox'
                  name='isFullBlock'
                  checked={localActivity.isFullBlock}
                  onChange={onChange}
                />
                {t('mgmt.activityModal.fullBlock')}
              </label>

              <label>
                <input
                  type='checkbox'
                  name='requireScan'
                  checked={localActivity.requireScan ?? true}
                  onChange={onChange}
                />
                {t('mgmt.activityModal.requiresScan')}
              </label>
            </div>
          </div>

          <div className='flex justify-end space-x-4 mt-4'>
            <ButtonComponent onClick={onClose} className='px-4 py-2 rounded-lg hover:bg-green-700'>
              {t('mgmt.common.cancel')}
            </ButtonComponent>
            <ButtonComponent onClick={handleSave} className='bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400'>
              {t('mgmt.common.save')}
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditActivityModal
